import { SAVE_ODSP_DATA } from 'constants/reduxActions';

const onDemandSize = (state = {}, action) => {
  const { data } = action;
  switch (action.type) {
    case SAVE_ODSP_DATA:
      return data;
    default:
      return state;
  }
};

export default onDemandSize;
